export default function ClientProfileSection() {
  return <>Client - Profile</>;
}
